import React, { PureComponent } from 'react';
import { PropTypes } from 'prop-types';
import moment from 'moment';
import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';
import RedirectButton from 'components/Common/Buttons/RedirectButton';

class CustomerFormList extends PureComponent {
  static propTypes = {
    onConfirmFormUnlink: PropTypes.func.isRequired,
    permissions: PropTypes.arrayOf(PropTypes.string),
    customer: PropTypes.shape(),
  };

  static defaultProps = {
    permissions: null,
    customer: {
      forms: []
    }
  };

  render() {
    const { permissions, customer, onConfirmFormUnlink } = this.props;
    return (
      <div>
        <div>
          <table className="table table-striped table-hover table-bordered">
            <thead>
              <tr>
                <th>Form Type</th>
                <th>Date Uploaded</th>
                <th>Expiration Date</th>
                <th>Signed Date</th>
                <th>Original Filename</th>
                <th>View/Action</th>
              </tr>
            </thead>
            <tbody>
              { (customer != null && customer.forms != null && customer.forms.length > 0)
                && customer.forms.map(formData => formData != null && <tr key={ formData.id }>
                  <td align="center">{ formData.formTypeDescription }</td>
                  <td align="center">{ moment(formData.dateUploaded).format('MMM DD, YYYY') }</td>
                  <td align="center">      {(() => {
                    if (formData.validUntil && formData.validUntil !== null) {
                      if (formData.validUntil.includes('9999')) {
                        return 'Evergreen';
                      }
                      return moment(formData.validUntil).format('MMM DD, YYYY');
                    }
                    return '';
                  })()}
                  </td>
                  <td align="center"> {formData.dateSigned !== null ? moment(formData.dateSigned).format('MMM DD, YYYY') : ''} </td>
                  <td>{ formData.originalFileName }</td>
                  <td className="form-action-btn-group">
                    {
                      (
                        (formData.isOnlineForm
                          && AccessControl.hasPermission(
                            permissions,
                            [
                              ActivityPerms.electronicView,
                              ActivityPerms.electronicValidate
                            ]
                          )
                        ) || (
                          !formData.isOnlineForm
                          && AccessControl.hasPermission(
                            permissions,
                            [
                              ActivityPerms.scannedView,
                              ActivityPerms.scannedEdit,
                              ActivityPerms.scannedValidate
                            ]
                          )
                        )
                      ) && formData.formType && formData.formType.toLowerCase() !== 'unknown' && <RedirectButton
                        to={ `/forms/${ formData.formType.toLowerCase() }/${ formData.id }` }
                        title={ <span className="icon icon-apps" /> }
                        hint="Reopen"
                        className="btn btn-sm"
                      />
                    }
                    { ((formData.isOnlineForm && AccessControl.hasPermission(
                      permissions,
                      [
                        ActivityPerms.electronicDelete
                      ]
                    )
                    )
                      || (
                        !formData.isOnlineForm
                          && AccessControl.hasPermission(
                            permissions,
                            [
                              ActivityPerms.scannedDelete
                            ]
                          )
                      )
                    ) && formData.formType && formData.formType.toLowerCase() !== 'unknown' && AccessControl.hasPermission(
                      permissions,
                      [
                        ActivityPerms.customerPageEdit
                      ]
                    ) && <button
                      className="btn btn-sm btn-danger"
                      onClick={ () => onConfirmFormUnlink(formData.id) }
                      type="button"
                      title="Unlink form"
                    >
                      <span className="icon icon-delete" />
                    </button> }
                  </td>
                </tr>) }
              { (!customer || !customer.forms || customer.forms.length === 0)
                && <tr><td colSpan="7" style={ { textAlign: 'center' } }><p><b>No Data to Show</b></p></td></tr> }
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default CustomerFormList;
